var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderStock',{attrs:{"header":"คลัง","img_header":_vm.header_image,"link_back":"alllot"}}),_c('MenuStockList'),_c('LotDetailOutEditList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }